import Util from '@/util'
import uploadBtn from 'vuetify-upload-button'

let uploadImage = {
  components: {
    uploadBtn
  },
  data () {
    return {
      images: [],
      imageSize: 0,
      imageMaxSize: 10,
      imageMaxLength: 3
    }
  },
  methods: {
    deleteImage (index) {
      this.imageSize = this.imageSize - this.images[index].size
      this.images.splice(index, 1)
    },
    imageTotalSize (list) {
      this.imageSize = 0
      this.images = []
      if (list.length > 0) {
        list.map((d) => {
          this.imageSize = this.imageSize + d.size
          this.images.push({
            src: d.imageUrl,
            size: d.size
          })
        })
      }
    },
    imageValidation (file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          reject(new Error())
        }
        if (this.images.length >= this.imageMaxLength) {
          reject(new Error(`最大数(${this.imageMaxLength}個)を超過しました。`))
        }
        if ((this.imageSize + file.size) / (1024 * 10240) > this.imageMaxSize) {
          reject(new Error(`最大容量(${this.imageMaxSize}MB)を超過しました。`))
        }
        const validTypes = ['image/png', 'image/jpeg', 'image/bmp']
        if (!validTypes.includes(file.type)) {
          this.$alertMsg('許可されていないファイル拡張子です。')
          return
        }
        const img = new Image()
        img.src = window.URL.createObjectURL(file)
        img.onload = () => {
          // if (img.width > 1000 || img.height > 1000) {
          //   reject(new Error('最大解像度(1000px*1000px)を超過しました。'))
          // } else {
          const formData = new FormData()
          formData.append('file', file)
          formData.append('loginId', Util.parseLoginToken().loginId)
          formData.append('isMms', true)
          resolve(formData)
          // }
        }
      })
    },
    uploadImage (file) {
      this.imageValidation(file)
        .then((formData) => {
          this.axios
            .post('/api/external/fileUpload', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then((res) => {
              if (res.status === 200 && res.data.code === 0) {
                this.imageSize = this.imageSize + file.size
                this.images.push({
                  src: res.data.data.imageUrl,
                  size: file.size
                })
              } else {
                this.$alertMsg('画像のアップロードに失敗しました。')
              }
            })
        })
        .catch((err) => {
          if (err.message) {
            this.$alertMsg(err.message)
          }
        })
    }
  }
}

export default uploadImage



// WEBPACK FOOTER //
// ./src/components/mixin/UploadImages.js